import React, { useEffect, useState, useContext } from 'react'

import styles from './GerenteAdministrativo.module.css'
import Subtitle from '../Subtitle'

import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const GerenteAdministrativo = ({ contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [ documentos, setDocumentos ] = useState([])

    const handleChangeTexto = (event, campo) => {
        let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = Funciones.mostrarCamelCase(valor)
        let campoAux = ''
        if (campo === 'nombres') {
            campoAux = 'nombresGA'
        } else if (campo === 'apellidoPaterno') {
            campoAux = 'apellidoPaternoGA'
        } else if (campo === 'apellidoMaterno') {
            campoAux = 'apellidoMaternoGA'
        }

        setState((state) => {
            return {
            ...state,
            contratante: {
                ...state.contratante,
                gerenteAdministrativo: {
                    ...state.contratante.gerenteAdministrativo,
                    [campo]: capital
                }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campoAux]: true
            }
            }
        })
    }

    const handleChangeCombo = (event, campo) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    gerenteAdministrativo: {
                        ...state.contratante.gerenteAdministrativo,
                        [campo]: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        },
                        numeroDocumento: ''
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    tipoDocumentoGA: true
                }
            }
        })
    }

    const handleChangeNumerico = (e, campo, codigo) => {
        let valor = ''
        switch (codigo) {
            case 1:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            case 3:
                valor = e.target.value.replace(/[^0-9A-Z]/gi, "")
                valor = valor.toUpperCase()
                break;
            case 4:
                valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
                break;
            default:
                console.error('No existe un Tipo de documento válido')
        }
        setState((state) => {
            return {
            ...state,
            contratante: {
                ...state.contratante,
                gerenteAdministrativo: {
                    ...state.contratante.gerenteAdministrativo,
                    [campo]: valor
                }
                },
                campoValidado: {
                    ...state.campoValidado,
                    numeroDocumentoGA: true
            }
            }
        })
    }

    useEffect(() => {
        const cargarCombos = () => {
            setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
        }
        
        cargarCombos()
    }, [])

    const tamanioDocumento = (codigo) => {
        if (codigo !== null && codigo !== undefined) {
            return Constantes['CANTIDAD_DIGITOS_TIPO_DOCUMENTO_' + codigo]
        } else {
            return '0'
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
                <Subtitle
                    sname="Gerente general/Administrador"
                    smostrar="false"
                />
                <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                    <div className={styles['area50']}>
                        <label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            style={{paddingLeft: '2%'}}
                            className={!state.campoValidado.nombresGA ? styles['logerror'] : null}
                            value={contratante.gerenteAdministrativo !== null && contratante.gerenteAdministrativo !== undefined
                                ? contratante.gerenteAdministrativo.nombres || '' : ''}
                            onChange={(e) => handleChangeTexto(e, 'nombres')} 
                            disabled={Deshabilitar() !== true ? false : true}
                            maxLength={40}
                        />
                        {!state.campoValidado.nombresGA && 
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NOMBRES}</span>
                        }
                    </div>
                    <div className={styles['area25']}>
                        <label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            style={{paddingLeft: '3.5%'}}
                            className={!state.campoValidado.apellidoPaternoGA ? styles['logerror'] : null}
                            value={contratante.gerenteAdministrativo !== undefined && contratante.gerenteAdministrativo !== null
                                ? contratante.gerenteAdministrativo.apellidoPaterno || '' : ''}
                            onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')} 
                            disabled={Deshabilitar() !== true ? false : true}
                            maxLength={30}
                        />
                        {!state.campoValidado.apellidoPaternoGA && 
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_PATERNO}</span>
                        }
                    </div>
                    <div className={styles['area25']}>
                        <label>Apellido Materno&nbsp;{(contratante.gerenteAdministrativo !== undefined &&
                            contratante.gerenteAdministrativo.tipoDocumento && contratante.gerenteAdministrativo.tipoDocumento.codigo) !== 3 ? 
                            Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}</label>
                        <input type='text'
                            className={!state.campoValidado.apellidoMaternoGA ? styles['logerror'] : null}
                            value={contratante.gerenteAdministrativo !== null && contratante.gerenteAdministrativo !== undefined
                                ? contratante.gerenteAdministrativo.apellidoMaterno || '' : ''}
                            onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
                            disabled={Deshabilitar() !== true ? false : true}
                            maxLength={30}
                        />
                        {!state.campoValidado.apellidoMaternoGA && 
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_MATERNO}</span>
                        }
                    </div>
                </div>
                <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                    <div className={styles['area25']}>
                        <label>Tipo Doc.&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <select
                            className={!state.campoValidado.tipoDocumentoGA ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
                            value={contratante.gerenteAdministrativo !== null && contratante.gerenteAdministrativo !== undefined
                                && contratante.gerenteAdministrativo.tipoDocumento ?
                                contratante.gerenteAdministrativo.tipoDocumento.codigo.toString() : ''}
                            onChange={(e) => handleChangeCombo(e, 'tipoDocumento')}
                            disabled={Deshabilitar() !== true ? false : true}
                        >
                                <option value={0}>Seleccione</option>
                                {documentos && documentos.length > 0 && documentos.filter(doc => {return doc.id !== 2 && doc.id !== 5 && doc.id !== 4}).map(documento => (
                                    <option key={documento.id} value={documento.id}>
                                        {documento.valor}
                                    </option>
                                ))}
                        </select>
                        <br></br>
                        {!state.campoValidado.tipoDocumentoGA && 
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
                        }
                    </div>
                    <div className={styles['area25']}>
                        <label>Nro. de Doc. Identidad&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='text'
                            className={!state.campoValidado.numeroDocumentoGA ? styles['logerror'] : null}
                            value={contratante.gerenteAdministrativo !== null && contratante.gerenteAdministrativo !== undefined
                                ? contratante.gerenteAdministrativo.numeroDocumento || '' : ''}
                            maxLength={tamanioDocumento(contratante.gerenteAdministrativo !== undefined &&
                                contratante.gerenteAdministrativo.tipoDocumento && contratante.gerenteAdministrativo.tipoDocumento.codigo)}
                            onChange={(e) => handleChangeNumerico(e, 'numeroDocumento', contratante.gerenteAdministrativo.tipoDocumento.codigo)}
                            disabled={Deshabilitar() !== true ? false : true}
                        />
                        {!state.campoValidado.numeroDocumentoGA && 
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
                        }
                    </div>
                    <div className={styles['area50']}></div>
                </div>
            </div>
    )
}

export default GerenteAdministrativo